import { Spin } from '../ui/semi';

export function LoadingIndicator() {
  return <span className="loading-indicator" role="status">
    <span className="loading-indicator-icon" aria-hidden="true"><Spin size="small" /></span>
    <span>加载中…</span>
  </span>;
}
